import * as React from 'react';
import { createPortal } from 'react-dom';
import { JobPosting } from '../../services/job-search-service';

/**
 *
 * @see https://developers.google.com/search/docs/guides/intro-structured-data
 * @see https://developers.google.com/search/docs/data-types/job-posting
 * @constructor
 */
export default function JobPostingData({job}: {job: JobPosting}) {
    const script = {
        '@context': 'https://schema.org',
        '@type': 'JobPosting',
        title: job.title,
        description: job.snippet,
        datePosted: new Date(job.timestamp).toISOString(),
        hiringOrganization: {
            '@type': 'Organization',
            name: job.company.name
            // sameAs: 'http://...'
            // logo: job.
        },
        jobLocation: {
            '@type': 'Place',
            'address': {
                '@type': 'PostalAddress',
                streetAddress: job.address.street,
                addressLocality: job.address.city,
                addressRegion: job.address.state,
                // postalCode: job.address.
                addressCountry: job.address.country
            }
        },
        // validThrough:
        // applicantLocationRequirements: {
        //     '@type': 'Country',
        //     'name': 'USA'
        // },
        // jobLocationType: 'TELECOMMUTE'
        // baseSalary: {
        //     '@type': 'MonetaryAmount',
        //     currency: 'USD',
        //     value: {
        //         '@type': 'QuantitativeValue',
        //         value: 40.00,
        //         minValue: 40.00,
        //         maxValue: 50.00,
        //         unitText: 'HOUR'
        //     }
        // },
        // employmentType: string or string[] -  'FULL_TIME' PART_TIME CONTRACTOR TEMPORARY INTERN VOLUNTEER PER_DIEM OTHER
        // identifier: {
        //     "@type": "PropertyValue",
        //     name: "MagsRUs Wheel Company",
        //     value: "1234567
        // }
    };

    return createPortal((
        <React.Fragment>
            <meta name="Description" content={job.snippet}/>
            <script type="application/ld+json">{JSON.stringify(script)}</script>
        </React.Fragment>
    ), document.head);
}
